import { useEffect, useState } from "react";
import { HR_SYSTEM } from "../../utils/constants";
import useIsIntegrated from "./useIsIntegrated";

function useHrIntegrations() {
  const { integrations, isIntegratedLoading } = useIsIntegrated();
  const [hrIntegrations, setHrIntegrations] = useState({
    isAnyHrIntegrated: false,
    integratedSystems: {},
    integratedSystemsList: [],
  });

  useEffect(() => {
    if (!isIntegratedLoading && integrations) {
      const integratedSystems = {};
      const integratedSystemsList = [];

      integrations.forEach((integration) => {
        if (HR_SYSTEM.includes(integration)) {
          integratedSystems[integration] = true;
          integratedSystemsList.push(integration);
        }
      });

      setHrIntegrations({
        isAnyHrIntegrated: integratedSystemsList.length > 0,
        integratedSystems,
        integratedSystemsList,
      });
    }
  }, [integrations, isIntegratedLoading]);

  return {
    isAnyHrIntegrated: hrIntegrations.isAnyHrIntegrated,
    integratedSystems: hrIntegrations.integratedSystems,
    integratedSystemsList: hrIntegrations.integratedSystemsList,
    isLoading: isIntegratedLoading,
  };
}

export default useHrIntegrations;
